(function () {
  // 防止同一版本重複載入
  if (window.__pairedGiftsV2) return;
  window.__pairedGiftsV2 = true;

const RULES = [
  {
    buy: [48175520252149, 48175521104117],
    gift: 48175519858933
  },
  {
    buy: [67601515675893], // A00569
    gift: 67675393491189   // A00569-1
  },
  {
    buy: [48175520678133], // A00481
    gift: 67816475689205   // A00604
  },
  {
    buy: [
      48877862224117, // A00486-1-1
      48877862256885, // A00486-1-2
      48877862289653, // A00486-1-3
      48877862322421, // A00486-1-4
      48877862355189, // A00486-1-5

      48877875495157, // A00486-2-1
      48877875527925, // A00486-2-2
      48877875560693, // A00486-2-3
      48877875593461, // A00486-2-4
      48877875626229, // A00486-2-5

      47222940729589, // A00006-1
      47222940762357, // A00006-3
      47222940795125, // A00006-5
      47222940827893, // A00006-4

      47222820929781, // A00005-1
      47222820962549, // A00005-3
      47222821060853, // A00005-5
      47222821093621, // A00005-4
      47222821159157  // A00005-2
    ],
    gift: 47223011082485 // A00010-1
  }
  ];

  const nativeFetch = window.fetch.bind(window);
  const root = window.Shopify?.routes?.root || '/';

  let running = false;
  let pending = false;
  let timer;
  let externalRequests = 0;
  let revision = 0;

  // sessionStorage 不可用時，改用目前頁面的記憶體
  const memory = new Map();

  function readState(rule) {
    const key = 'paired_gift_v2_' + rule.gift;
    try {
      const stored = sessionStorage.getItem(key);
      return stored ? JSON.parse(stored) : memory.get(key);
    } catch {
      return memory.get(key);
    }
  }

  function saveState(rule, state) {
    const key = 'paired_gift_v2_' + rule.gift;
    memory.set(key, state);

    try {
      sessionStorage.setItem(key, JSON.stringify(state));
    } catch {}
  }

  function quantities(cart, rule) {
    return {
      buy: cart.items
        .filter(item => rule.buy.includes(Number(item.variant_id)))
        .reduce((sum, item) => sum + item.quantity, 0),

      gift: cart.items
        .filter(item => Number(item.variant_id) === rule.gift)
        .reduce((sum, item) => sum + item.quantity, 0)
    };
  }

  async function request(path, options) {
    const response = await nativeFetch(root + path, options);
    const data = await response.json();

    if (!response.ok || !Array.isArray(data.items)) {
      throw new Error(
        data.description || data.message || 'Cart request failed'
      );
    }

    return data;
  }

  function schedule() {
    pending = true;
    clearTimeout(timer);

    timer = setTimeout(() => {
      sync().catch(error => {
        console.error('Paired gifts:', error);
      });
    }, 350);
  }

  async function refreshCartUI(cart) {
    // 使用和原版相同的主題元素，
    // 但不強制呼叫可能會打開抽屜的 renderContents。
    const response = await nativeFetch(window.location.href, {
      cache: 'no-store'
    });

    if (!response.ok) throw new Error('Cart UI refresh failed');

    const html = await response.text();
    const page = new DOMParser().parseFromString(html, 'text/html');

    const selectors = ['#cart-icon-bubble', 'cart-drawer'];

    if (/\/cart\/?$/.test(window.location.pathname)) {
      selectors.push(
        'cart-items',
        '.cart__contents',
        '[id$="__main-cart-footer"]',
        '#main-cart-footer',
        '.cart__footer-wrapper'
      );
    }

    // 避免重複替換父元素內的子元素
    const replaced = [];

    for (const selector of selectors) {
      const current = document.querySelector(selector);
      const next = page.querySelector(selector);

      if (!current || !next) continue;
      if (replaced.some(parent => parent.contains(current))) continue;

      current.innerHTML = next.innerHTML;

      if (selector === 'cart-drawer') {
        current.classList.toggle('is-empty', cart.item_count === 0);
      }

      replaced.push(current);
    }

    document.dispatchEvent(
      new CustomEvent('paired-gifts:updated', {
        detail: { cart }
      })
    );
  }

  async function sync() {
    if (running || externalRequests > 0 || !pending) return;

    running = true;
    pending = false;

    try {
      const startingRevision = revision;
      const cart = await request('cart.js', { cache: 'no-store' });

      // 讀取期間顧客又操作購物車，先等下一次檢查
      if (externalRequests > 0 || revision !== startingRevision) {
        pending = true;
        return;
      }

      const updates = {};

      for (const rule of RULES) {
        const current = quantities(cart, rule);
        const previous = readState(rule);

        let rejected = Boolean(previous?.rejected);

        if (current.buy === 0) {
          rejected = false;
        } else if (previous) {
          const buyReduction = Math.max(
            0, previous.buy - current.buy
          );
          const giftReduction = Math.max(
            0, previous.gift - current.gift
          );

          // 超出主商品減量的贈品減量，視作主動拒絕
          if (giftReduction > buyReduction) {
            rejected = true;
          }
        }

        // 拒絕後不補回，但仍移除超出資格的贈品
        const target = rejected
          ? Math.min(current.gift, current.buy)
          : current.buy;

        saveState(rule, { ...current, rejected });

        if (target === current.gift) continue;

        const lines = cart.items.filter(
          item => Number(item.variant_id) === rule.gift
        );

        if (lines.length === 0) {
          if (target > 0) updates[rule.gift] = target;
        } else {
          // 使用每行的 key，避免同款有多行時改錯行
          let remaining = target;

          lines.forEach((item, index) => {
            const quantity = index === lines.length - 1
              ? remaining
              : Math.min(item.quantity, remaining);

            remaining -= quantity;

            if (quantity !== item.quantity) {
              updates[item.key] = quantity;
            }
          });
        }
      }

      if (Object.keys(updates).length === 0) return;

      const updatedCart = await request('cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });

      // 只記錄伺服器實際回傳數量，不把目標當作成功結果
      for (const rule of RULES) {
        const state = readState(rule);

        saveState(rule, {
          ...quantities(updatedCart, rule),
          rejected: Boolean(state?.rejected)
        });
      }

      // 若期間又有顧客操作，先重新同步，避免渲染舊資料
      if (externalRequests > 0 || revision !== startingRevision) {
        pending = true;
        return;
      }

      await refreshCartUI(updatedCart);
    } finally {
      running = false;
      if (pending && externalRequests === 0) schedule();
    }
  }

  function isCartMutation(input) {
    try {
      const value = typeof input === 'string'
        ? input
        : input instanceof URL
          ? input.href
          : input?.url;

      const url = new URL(value, window.location.origin);

      return url.origin === window.location.origin &&
        /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(
          url.pathname
        );
    } catch {
      return false;
    }
  }

  window.fetch = async function (...args) {
    if (!isCartMutation(args[0])) {
      return nativeFetch(...args);
    }

    externalRequests++;
    revision++;

    try {
      return await nativeFetch(...args);
    } finally {
      externalRequests--;
      revision++;
      schedule();
    }
  };

  // 初次載入及瀏覽器返回頁面時也檢查
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, {
      once: true
    });
  } else {
    schedule();
  }

  window.addEventListener('pageshow', schedule);
})();
